import React from 'react';

import MagicLinkLayout from '@app/MagicLinkLogin/MagicLinkLayout';

import CheckYourEmailCard from './components/CheckYourEmailCard';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPassword = () => {
	const [resetEmailSent, setResetEmailSent] = React.useState(false);

	return (
		<MagicLinkLayout>
			{resetEmailSent ? (
				<CheckYourEmailCard />
			) : (
				<ForgotPasswordForm setResetEmailSent={setResetEmailSent} />
			)}
		</MagicLinkLayout>
	);
};

export default ForgotPassword;
